/**
 * Initializes a dynamic element module based on the specified key
 * @param {HTMLElement} element - The element that needs to be controlled
 * @param {string} key - The key that identifies which dynamic element module to initialize
 */
async function dynamicElementsService(element, key) {
  switch (key) {
    // If the key is "cashback", load the "cashback" module and initialize it
    case 'cashback': {
      const { initializeCashback } = await import('./elements/cashback');
      initializeCashback(element);
      break;
    }
    // If the key is "cashier", load the "cashier" module and initialize it
    case 'cashier': {
      const { initializeCashier } = await import('./elements/cashier');
      initializeCashier(element);
      break;
    }
    // If the key is "tournament", load the "tournament" module and initialize it
    case 'tournament': {
      const { initializeTournament } = await import('./elements/tournament');
      initializeTournament(element);
      break;
    }
    case 'favourite': {
      const { initializeFavourite } = await import('./elements/favourite');
      initializeFavourite(element);
      break;
    }
    case 'game-window-search': {
      const { initializeSearch } = await import('./elements/search');
      initializeSearch(element);
      break;
    }
    case 'modal-games-collections': {
      const { initializeGameWindowCollections } = await import('./elements/collections');
      initializeGameWindowCollections();
      break;
    }
    // If the key is not recognized, do nothing
    default:
      break;
  }
}

export { dynamicElementsService };
